import { render, staticRenderFns } from "./BulkActionsMenu.vue?vue&type=template&id=95aa35c0&scoped=true&"
import script from "./BulkActionsMenu.vue?vue&type=script&lang=ts&"
export * from "./BulkActionsMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BulkActionsMenu.vue?vue&type=style&index=0&id=95aa35c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aa35c0",
  null
  
)

export default component.exports